angular.module( 'acme.view.application.orders.requests.modals.tickets', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.orders.requests.modals.tickets.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var ordersRequestsModalsTickets = {
        name: 'application.orders.requests.modals.tickets',
        url: '/orders/requests/modals/tickets',
        views: {
          "main": {
            controller: 'OrdersRequestsModalsTicketsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/orders/requests/modals/tickets/tickets.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(ordersRequestsModalsTickets);
});
